import * as types from "../actions/actionTypes";
import initialState from "./initialState";
// import { getFieldInstance } from "./utils";

const deSerializeWebhooks = (integration) => {
  const webhooks = [];
  integration.webhooks.forEach((webhook) => {
    webhooks.push(deSerializeWebhook(webhook));
  });
  return webhooks;
};

const deSerializeWebhook = (webhook) => {
  const headers = [];
  //const responseBody = [];

  Object.keys(webhook.headers).forEach((key, index) => {
    if (key) {
      const value = webhook.headers[key];
      headers.push({
        ["resHeaderKey_" + index]: key,
        ["resHeaderValue_" + index]: value,
      });
    }
  });

  // Object.keys(webhook.responseBody).forEach((key, index) => {
  //   if (key) {
  //     const value = webhook.responseBody[key];
  //     responseBody.push({
  //       ["resBodyKey_" + index]: key,
  //       ["resBodyValue_" + index]: value,
  //     });
  //   }
  // });

  return [
    webhook.name,
    webhook.url,
    webhook.method,
    webhook.requestType,
    headers,
    //responseBody,
  ];
};

export default function integrationReducer(
  state = initialState.integration,
  action
) {
  switch (action.type) {
    case types.SET_INTEGRATION_CONFIG_TYPE: {
      const configType = action.payload.type;
      return { ...state, configType };
    }
    case types.ADD_WEBHOOK: {
      const webhook = action.payload;
      return { ...state, webhooks: webhook };
    }
    case types.REMOVE_WEBHOOK: {
      const { webhook } = action.payload.webhook;
      return { ...state, webhook };
    }
    case types.GET_TEMPLATE_SUCCESS: {
      const {
        template: { integration },
      } = action;
      return {
        ...state,
        configType: integration
          ? integration.configType
          : initialState.integration.configType,
        webhooks: integration
          ? deSerializeWebhooks(integration)
          : initialState.integration.webhooks,
      };
    }
    default:
      return state;
  }
}
